import { OwnerReportOutput, OwnerType } from 'gql/types';
import { TFunction } from 'i18next';
import { ReportFilterOptions } from 'modules/reports/hooks/useReportFilterOptions';
import { ReportFilterConfig } from 'modules/reports/types';

export const getOwnerReportFilters = (
  t: TFunction,
  { regionNames, locationNames }: ReportFilterOptions
): ReportFilterConfig<OwnerReportOutput>[] => [
  {
    key: 'regions',
    label: t('regions'),
    type: 'multiselect',
    getValue: (item) => item.regions,
    options: regionNames,
  },
  {
    key: 'locationPreferences',
    label: t('locationPreferences'),
    type: 'multiselect',
    getValue: (item) => item.locationPreferences,
    options: locationNames,
  },
  {
    key: 'type',
    label: t('type'),
    type: 'multiselect',
    getValue: (item) => item.type,
    options: Object.values(OwnerType),
  },
  {
    key: 'state',
    label: t('state'),
    type: 'multiselect',
    getValue: (item) => item.state,
  },
  {
    key: 'isArchived',
    label: t('isArchived'),
    type: 'multiselect',
    getValue: (item) => (item.isArchived ? 'Yes' : 'No'),
    options: ['Yes', 'No'],
  },
];
